import { useState } from "react";
import "../../../../../styles/ComponentsStyles/Setting/Permission/ActAdminVertical.style.css";
import ProfileViewer from "../../../../Universal/Profiles/ProfileViewer.component";
import SearchIcon from "../../../../../assets/Icons/Universal/Search.svg";
import PermissionPathAccessList from "./PermissionPathAccessList.component";

const ActAdminVertical = () => {
  const [selectedProfile, setSelectedProfile] = useState("0");
  return (
    <div className=" flex-col flex-1 w-full h-full radius-10 back-white align-left pt-2 pb-2 pl-3 pr-3 g-1">
      <h3 className="t-16 poppins color-black weight-500">
        Here you can add admin as an act admin. They can get all access except
        settings portion.
      </h3>
      <div
        className="flex-col align-left justify-start scroll-y w-full pr-05"
        style={{ height: "28vh" }}
      >
        <div className="verticalAccessActAdminSelectProfileParentContainer">
          {[...Array(10)].map((_, index) => {
            return (
              <div className="verticalAccessActAdminSelectProfileCards">
                <ProfileViewer
                  name={"Md Rejuwanul karim"}
                  _id={"SM4562"}
                  imageHeight={"3rem"}
                  imageWidth={"3rem"}
                  imageSource={"https://randomuser.me/api/portraits/men/53.jpg"}
                  className={"verticalAccessActAdminSelectProfile"}
                />
                <input
                  type="radio"
                  name="profileChanger"
                  value={index.toString()}
                  onChange={(e) => setSelectedProfile(e.target.value)}
                  checked={selectedProfile === index.toString()}
                />
              </div>
            );
          })}
        </div>
      </div>

      <div
        className="overflow-hide p-05 flex-1 flex-col align-left justify-start radius-10  w-full back-white p-1 g-05"
        style={{ border: "2px solid var(--grayBorder)" }}
      >
        <div
          className="flex-col align-left justify-start g-05 w-full "
          style={{ height: "5.7rem" }}
        >
          <div className="searchInputContainer">
            <input
              type="text"
              className="pageHeaderInput"
              placeholder="Type for search"
            />
            <button className="searchBtn">
              <img src={SearchIcon} alt="Search" />
            </button>
          </div>
          <hr color="#b0b0b0" className="w-full" />
          <div className="w-full g-05 flex-row align-center justify-between">
            <span className="t-12 color-black poppins">Settings</span>
            <hr color="#b0b0b0" className="w-full" />
            <div className="toggleBtn flex-row align-center justify-start">
              <span className="t-12 color-black poppins text-no-wrap">
                Access all of the settings
              </span>
              <input type="checkbox" name="allsettings" id="allsettings" />
            </div>
          </div>
        </div>

        <div className="w-full flex-1 scroll-y flex-col align-left justify-start g-2 pr-05">
          <div className="w-full flex-col align-left justify-start g-2">
            <PermissionPathAccessList
              backColor={"#9A869F"}
              pathNames={[
                "Profile/Institutional details/Basic",
                "Profile/Institutional details/Advance",
              ]}
            />
            <PermissionPathAccessList
              backColor={"#7AA5AB"}
              pathNames={[
                "Permission/Manage co-admin/Sub admin",
                "Permission/Vertical access/For sub admin",
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActAdminVertical;
